import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const displayFont = { fontFamily: "'Fraunces', serif" };
const bodyFont = { fontFamily: "'Sora', sans-serif" };

const fieldClass =
  "w-full px-4 py-2.5 bg-white border border-[#E3E8F0] rounded-xl text-[#101826] placeholder-[#A6AFBD] text-sm shadow-[0_1px_2px_rgba(16,24,38,0.04)] outline-none transition-[box-shadow,border-color] duration-200 ease-out focus:border-[#2E63B8] focus:shadow-[0_0_0_4px_rgba(46,99,184,0.15)]";
const labelClass = "block text-[13px] mb-1.5 text-[#5A6478] font-medium";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const changeHandler = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/v1/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Login failed");
      }

      localStorage.setItem("adminToken", data.token);
      localStorage.setItem("adminInfo", JSON.stringify(data.admin));
      toast.success(`Welcome back, ${data.admin.name}`);
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error(error.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-4 bg-gradient-to-b from-[#0E2748] to-[#163863]"
      style={bodyFont}
    >
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden">
        <div className="h-[4px] w-full bg-gradient-to-r from-[#E8A63C] via-[#2E63B8] to-[#163863]" />
        <div className="p-8">
          <h1 style={displayFont} className="text-2xl text-[#101826] mb-1">
            Admin Console
          </h1>
          <p className="text-[#5A6478] text-sm mb-6">
            Sign in to manage school registrations
          </p>

          <form onSubmit={submitHandler} className="space-y-5">
            <div>
              <label className={labelClass} htmlFor="email">Email</label>
              <input
                type="email"
                required
                name="email"
                id="email"
                value={formData.email}
                onChange={changeHandler}
                className={fieldClass}
                placeholder="admin@isnartech.com"
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="password">Password</label>
              <input
                type="password"
                required
                name="password"
                id="password"
                value={formData.password}
                onChange={changeHandler}
                className={fieldClass}
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 rounded-full bg-gradient-to-r from-[#163863] to-[#2E63B8] text-white text-[15px] font-semibold shadow-lg shadow-[#163863]/25 hover:shadow-xl transition-all duration-200 disabled:opacity-50"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
